import type {
  AccordionFragment,
  EmbedAccordionGroupFragment,
  EmbedComponentFragment,
  EmbedCustomContentFragment,
  RichTextAccordionFragment,
} from '@seek/cmsu-cms-connect';
import { AccordionGroup } from '@seek/cmsu-components';
import { renderers } from '@seek/cmsu-rich-text';
import { Badge, Box, ContentBlock, Divider } from 'braid-design-system';
import React from 'react';

import type { ArticleAdditionalData } from 'src/client/pages/Article';

import { CustomContent } from '../../CustomContent/CustomContent';

export const toAccordions = (
  accordions: RichTextAccordionFragment[],
): AccordionFragment[] =>
  accordions.map((accordion) => ({
    id: accordion.id,
    label: accordion.label,
    content: accordion.content,
    locale: accordion.locale,
  }));

export const richTextRenderers = (additionalData?: ArticleAdditionalData) => ({
  ...renderers,
  embed: {
    EmbedAccordionGroup: ({ accordion }: EmbedAccordionGroupFragment) => (
      <Box background="surface" paddingX="gutter" paddingY="gutter">
        <ContentBlock>
          <AccordionGroup accordions={toAccordions(accordion)} />
        </ContentBlock>
      </Box>
    ),
    EmbedCustomContent: ({ title }: EmbedCustomContentFragment) => (
      <CustomContent title={title} additionalData={additionalData} />
    ),
    EmbedComponent: ({ component }: EmbedComponentFragment) =>
      embedComponentRenderers(component),
  },
});

const embedComponentRenderers = (
  component?: EmbedComponentFragment['component'],
) => {
  if (!component) return <React.Fragment />;

  switch (component.__typename) {
    case 'LineDivider':
      return <Divider weight={component.weight || 'regular'} />;
    case 'Badge':
      return <Badge tone={component.tone}>{component.text}</Badge>;
    default:
      return <React.Fragment />;
  }
};
